export default __webpack_public_path__ + "static/media/0xee7666aacaefaa6efeef62ea40176d3eb21953b9.713067fc.webp";